import CachedIcon from '@mui/icons-material/Cached';
import EditIcon from '@mui/icons-material/Edit';
import PublishedWithChangesIcon from '@mui/icons-material/PublishedWithChanges';
import { Card, CardContent, CardHeader, IconButton, Typography } from "@mui/material";
import CircularProgress from '@mui/material/CircularProgress';
import * as React from "react";
import { connect } from "react-redux";
import { SettingInformationModel, UpdateResult } from '../../../models';
import { ApplicationState, FetchState, actionCreators, selectors } from "../../../store";
import FetchHelper from '../../FetchHelper';
import { disabledRefreshAllBtnStyle, disabledRefreshSuccessIconStyles, enableRefreshAllBtnStyle, enableRefreshSuccessIconStyles } from '../../styles';
import SelectSettingInformationDialog_TJ360DeviceVerson from '../../dialogs/SelectSettingInformationDialog_TJ360DeviceVerson';

const NO_OF_POLLING_TOPIC = 8;
const params = {
    mainid: "",
    isRefreshAllBegin: 0,
    loadingRefreshAll: [false],
    isEdit: false,
    isRefreshGroup: false,
    isDisbleRefeshBtn: true,
    isDisbleUpdateBtn: true,
    centralId: "",
    isRefreshAllCompleted: (status: number) => { },
    setIsEdit: (isEdit: boolean) => { },
    setRefreshGroup: (disabled: boolean, name: string) => { },
    setDisabledRefreshGroupBtn: (disabled: boolean, name: string) => { },
}

type SettingInformationProps = {
    defaultData: SettingInformationModel | undefined;
    deviceNo?: string;
    isRefreshSuccessDeviceNo?: boolean;
    onRefreshComplete?: () => void;
};

export type PureSettingInformationProps = SettingInformationProps & ReturnType<typeof mapStateToProps> &
    typeof mapDispatchToProps & typeof params;

const colStyleTitle = {
    width: '40%',
    border: 'none',
}

const colStyle = {
    border: 'none',
}

const fetchId = "SETTING_INFORMATION_FETCH";

export const SettingInformation_TJ360VersionDevice = (props: PureSettingInformationProps) => {
    const { defaultData, fetchState, mainid, isRefreshAllBegin, loadingRefreshAll, isEdit, isRefreshGroup, isDisbleRefeshBtn, isDisbleUpdateBtn, centralId, deviceNo, isRefreshSuccessDeviceNo } = props;
    const { onError, onUpdate, onRefresh, onUpdateError, onUpdateSuccess, isRefreshAllCompleted, setIsEdit, setRefreshGroup, setDisabledRefreshGroupBtn } = props;
    const [openSelectDialog, setOpenSelectDialog] = React.useState(false);
    const [updateData, setUpdateData] = React.useState<any>();
    const [settingInformation, setSettingInformation] = React.useState<SettingInformationModel | null>(fetchState.data);
    const [editData, setEditData] = React.useState<SettingInformationModel>();
    const [fetchLoading, setFetchLoading] = React.useState(false);
    const [editFlg, setEditFlg] = React.useState(false);
    const [isFetchAll, setIsFetchAll] = React.useState(false);
    const [isRefreshSuccess, setIsRefreshSuccess] = React.useState(false);

    React.useEffect(() => {
        if(!isRefreshSuccessDeviceNo)
            setIsRefreshSuccess(false);
    }, [isRefreshSuccessDeviceNo]);

    // パラメータ設定
    const handleFetchParams = () => {
        const params = new Map<string, any>();
        const code = "PU";
        params.set("code", code);
        params.set("mainid", mainid);
        params.set("device_no", deviceNo);
        params.set("centralid", centralId); 
        return params;
    }

    const convertIo = (input: string) => {
        let result = input;
        if (!input) return '';
        switch (input) {
            case '01':
                result = '01：(未使用)Ior自動設定';
                break;
            case '02':
                result = '02：Ior手動設定';
                break;
            case '03':
                result = '03：Io設定';
                break;
            case "04":
                result = '04：負荷電流';
                break;
        }
        return result;
    }

    const convertPhase = (input: string) => {
        let result = input;
        if (!input) return '';
        switch (input) {
            case '01':
                result = '01：単相変圧器';
                break;
            case '03':
                result = '03：三相変圧器';
                break;
        }
        return result;
    }

    const convertAngle = (input: string) => {
        let result = input;
        if (!input) return '';
        switch (input) {
            case '000':
                result = '000：0°';
                break;
            case '030':
                result = '030：30°';
                break;
            case '060':
                result = '060：60°';
                break;
            case '090':
                result = '090：90°';
                break;
            case '120':
                result = '120：120°';
                break;
            case '150':
                result = '150：150°';
                break;
        }
        return result;
    }

    const convertZct = (input: string) => {
        let result = input;
        if (!input) return '';
        switch (input) {
            case "0001":
                result = "0001：4500：1";
                break;
            case "0002":
                result = "0002：2000：1";
                break;
            case "0003":
                result = "0003：OTG-AA42";
                break;
            case "0004":
                result = "0004：CTF-05A";
                break;
        }
        return result;
    }

    const handleFetchSuccess = (data: any, action: string, isClickedRefreshBtn: boolean) => {
        setEditFlg(false);
        (loadingRefreshAll[NO_OF_POLLING_TOPIC - 1] === true) && (loadingRefreshAll[NO_OF_POLLING_TOPIC - 1] = false);
        const resData = {
            mainid: data.mainid,
            deviceNo: data.device_no,
            Io1: convertIo(data.Io1),
            Io2: convertIo(data.Io2),
            Io3: convertIo(data.Io3),
            Io4: convertIo(data.Io4),
            Io5: convertIo(data.Io5),
            Io6: convertIo(data.Io6),
            phase1: convertPhase(data.phase1),
            phase2: convertPhase(data.phase2),
            phase3: convertPhase(data.phase3),
            phase4: convertPhase(data.phase4),
            phase5: convertPhase(data.phase5),
            phase6: convertPhase(data.phase6),
            angle1: convertAngle(data.angle1),
            angle2: convertAngle(data.angle2),
            angle3: convertAngle(data.angle3),
            angle4: convertAngle(data.angle4),
            angle5: convertAngle(data.angle5),
            angle6: convertAngle(data.angle6),
            zct1: convertZct(data.zct1),
            zct2: convertZct(data.zct2),
            zct3: convertZct(data.zct3),
            zct4: convertZct(data.zct4),
            zct5: convertZct(data.zct5),
            zct6: convertZct(data.zct6),
            ctratio1: data.ctratio1,
            ctratio2: data.ctratio2,
            ctratio3: data.ctratio3,
            ctratio4: data.ctratio4,
            ctratio5: data.ctratio5,
            ctratio6: data.ctratio6,
            lastGetDatetime: data.last_get_datetime,
        } as SettingInformationModel;

        setSettingInformation(resData);
        setFetchLoading(false);
        isClickedRefreshBtn && setIsRefreshSuccess(true);
        
        if (isRefreshAllBegin === NO_OF_POLLING_TOPIC) {
            isRefreshAllCompleted(isRefreshAllBegin + 1);
        }
        setRefreshGroup(false, fetchId);

        if (action === 'edit') {
            setEditData(data);
            setOpenSelectDialog(true);
        }
    };

    const handleError = (success: boolean, data: any, error: any) => {
        onError(success, data, error);
        setEditFlg(false);
        (loadingRefreshAll[NO_OF_POLLING_TOPIC - 1] === true) && (loadingRefreshAll[NO_OF_POLLING_TOPIC - 1] = false);
        setFetchLoading(false);
        setIsRefreshSuccess(false);
        if (isRefreshAllBegin !== 0) {
            isRefreshAllCompleted(isRefreshAllBegin + 1);
        }
        setRefreshGroup(false, fetchId);
    }

    const handleRefresh = () => {
        const params = handleFetchParams();
        onRefresh(params, fetchId + deviceNo);
        setFetchLoading(true);
        setIsRefreshSuccess(false);
    };

    const handleRefreshSuccess = (data: any) => {
        editFlg ? handleFetchSuccess(data, 'edit', true) : handleFetchSuccess(data, 'view', true);
        props.onRefreshComplete?.();
    }

    const [updateDialogTitle, setUpdateDialogTitle] = React.useState('');
    const handleEdit = () => {
        setEditFlg(true);
        const params = handleFetchParams();
        onRefresh(params, fetchId + deviceNo);
        setUpdateDialogTitle(`Io/Ior設定情報取得`);
        setFetchLoading(true);
        setIsRefreshSuccess(false);
    };

    const handleUpdateEquipmentOk = (request: any) => {
        setOpenSelectDialog(false);
        const code = "PV";
        const requestData = {
            mainid: request.mainid,
            device_no: deviceNo,
            centralid: centralId,
            channelno: request.channelno,
            Io: request.Io,
            phase: request.phase,
            angle: request.angle,
            zct: request.zct,
            ctratio: request.ctratio,
        }
        onUpdate(code, mainid, requestData);
        setUpdateData(request);
        setFetchLoading(true);
        setIsRefreshSuccess(false);
    };

    const handleUpdateEquipmentCancel = () => {
        setOpenSelectDialog(false);
    };

    const handleUpdateSuccess = (success: boolean, data: any, error: any) => {
        const result = {
            mainid: data.mainid,
            deviceNo: data.device_no,
            channelno: data.channelno,
            resultCode: data.result_code,
        } as UpdateResult;
        if (result.resultCode === '0') {
            setUpdateDataToView(updateData, result.deviceNo, result.channelno);
            onUpdateSuccess();
        } else {
            handleUpdateError(success, data, error);
        }
    }

    const setUpdateDataToView = (updateData: any, deviceNo: string, channelno: string | undefined) => {
        setEditFlg(false);
        let newData:any = { ...settingInformation };
        newData[`Io${Number(channelno)}`] = convertIo(updateData.Io);
        newData[`phase${Number(channelno)}`] = convertPhase(updateData.phase);
        newData[`angle${Number(channelno)}`] = convertAngle(updateData.angle);
        newData[`zct${Number(channelno)}`] = convertZct(updateData.zct);
        newData[`ctratio${Number(channelno)}`] = updateData.ctratio;
        newData[`lastGetDatetime`] = updateData.last_get_datetime;
        setSettingInformation(newData);
        setFetchLoading(false);
        setIsRefreshSuccess(true);
    }

    const handleUpdateError = (success: boolean, data: any, error: any) => {
        setFetchLoading(false);
        setIsRefreshSuccess(true);
        onUpdateError(success, data, error);
    }

    const refreshAll = () => {
        if (isRefreshAllBegin === NO_OF_POLLING_TOPIC) {
            console.log("fetch No:______" + isRefreshAllBegin);
            handleRefresh();
        }
        if (isRefreshGroup === true) {
            handleRefresh();
            setFetchLoading(true);
            setIsRefreshSuccess(false);
        }
        if (loadingRefreshAll[NO_OF_POLLING_TOPIC - 1] === true) {
            setFetchLoading(true);
            setIsRefreshSuccess(false);
        }
        isRefreshAllBegin > 0 || isRefreshGroup ? setIsFetchAll(true) : setIsFetchAll(false);
    }
    // eslint-disable-next-line
    React.useEffect(refreshAll, [isRefreshAllBegin, loadingRefreshAll, isRefreshGroup]);

    const handleDisabledRefreshAll = () => {
        if (!fetchLoading) {
            setDisabledRefreshGroupBtn(false, fetchId);
        } else {
            setDisabledRefreshGroupBtn(true, fetchId);
        }
    }
    // eslint-disable-next-line
    React.useEffect(handleDisabledRefreshAll, [fetchLoading]);

    React.useEffect(() => {
        editFlg ? setIsEdit(true) : setIsEdit(false);
        // eslint-disable-next-line
    }, [editFlg])

    React.useEffect(() => {
        defaultData && handleFetchSuccess(defaultData, 'view', false);
        if(!defaultData) {
            setSettingInformation(null);}
        // eslint-disable-next-line
    }, [defaultData]);
    return (
        <>
            <Card style={{ margin: '0 auto 12px', backgroundColor: '#f5faff', width: '100%' }}>
                <CardHeader
                    avatar={
                        <PublishedWithChangesIcon style={isRefreshSuccess ? enableRefreshSuccessIconStyles : disabledRefreshSuccessIconStyles} />
                    }
                    action={
                        <div>
                            <IconButton aria-label="edit" onClick={handleEdit} disabled={isDisbleUpdateBtn || isEdit || fetchLoading || isFetchAll}>
                                <EditIcon fontSize="medium" style={isDisbleUpdateBtn || isEdit === true || fetchLoading || isFetchAll ? disabledRefreshAllBtnStyle : enableRefreshAllBtnStyle} />
                            </IconButton>
                            <IconButton aria-label="refresh" onClick={handleRefresh} disabled={isDisbleRefeshBtn || editFlg || fetchLoading || isFetchAll}>
                                <CachedIcon fontSize="medium" style={isDisbleRefeshBtn || editFlg === true || fetchLoading || isFetchAll ? disabledRefreshAllBtnStyle : enableRefreshAllBtnStyle} />
                            </IconButton>
                        </div>
                    }
                    title={`Io/Ior設定情報`}
                    titleTypographyProps={{ variant: 'h5' }}
                />
                <CardContent style={{ padding: '0 0 16px 0', minHeight: '200px' }}>
                    {fetchLoading ? (
                        <div style={{ display: 'flex', position: 'relative' }}>
                            <table className='polling' style={{ borderCollapse: 'collapse', width: '100%', margin: 'auto' }}>
                                <tbody>
                                    <tr>
                                        <td style={colStyleTitle}>Io/Ior設定1</td>
                                    </tr>
                                    <tr>
                                        <td style={colStyleTitle}>Io/Ior設定2</td>
                                    </tr>
                                    <tr>
                                        <td style={colStyleTitle}>Io/Ior設定3</td>
                                    </tr>
                                    <tr>
                                        <td style={colStyleTitle}>Io/Ior設定4</td>
                                    </tr>
                                    <tr>
                                        <td style={colStyleTitle}>Io/Ior設定5</td>
                                    </tr>
                                    <tr>
                                        <td style={colStyleTitle}>Io/Ior設定6</td>
                                    </tr>
                                    <tr>
                                        <td style={colStyleTitle}>変圧器種類1</td>
                                    </tr>
                                    <tr>
                                        <td style={colStyleTitle}>変圧器種類2</td>
                                    </tr>
                                    <tr>
                                        <td style={colStyleTitle}>変圧器種類3</td>
                                    </tr>
                                    <tr>
                                        <td style={colStyleTitle}>変圧器種類4</td>
                                    </tr>
                                    <tr>
                                        <td style={colStyleTitle}>変圧器種類5</td>
                                    </tr>
                                    <tr>
                                        <td style={colStyleTitle}>変圧器種類6</td>
                                    </tr>
                                    <tr>
                                        <td style={colStyleTitle}>位相補正角設定1</td>
                                    </tr>
                                    <tr>
                                        <td style={colStyleTitle}>位相補正角設定2</td>
                                    </tr>
                                    <tr>
                                        <td style={colStyleTitle}>位相補正角設定3</td>
                                    </tr>
                                    <tr>
                                        <td style={colStyleTitle}>位相補正角設定4</td>
                                    </tr>
                                    <tr>
                                        <td style={colStyleTitle}>位相補正角設定5</td>
                                    </tr>
                                    <tr>
                                        <td style={colStyleTitle}>位相補正角設定6</td>
                                    </tr>
                                    <tr>
                                        <td style={colStyleTitle}>ZCT/Relay種類1</td>
                                    </tr>
                                    <tr>
                                        <td style={colStyleTitle}>ZCT/Relay種類2</td>
                                    </tr>
                                    <tr>
                                        <td style={colStyleTitle}>ZCT/Relay種類3</td>
                                    </tr>
                                    <tr>
                                        <td style={colStyleTitle}>ZCT/Relay種類4</td>
                                    </tr>
                                    <tr>
                                        <td style={colStyleTitle}>ZCT/Relay種類5</td>
                                    </tr>
                                    <tr>
                                        <td style={colStyleTitle}>ZCT/Relay種類6</td>
                                    </tr>
                                    <tr>
                                        <td style={colStyleTitle}>CT比1</td>
                                    </tr>
                                    <tr>
                                        <td style={colStyleTitle}>CT比2</td>
                                    </tr>
                                    <tr>
                                        <td style={colStyleTitle}>CT比3</td>
                                    </tr>
                                    <tr>
                                        <td style={colStyleTitle}>CT比4</td>
                                    </tr>
                                    <tr>
                                        <td style={colStyleTitle}>CT比5</td>
                                    </tr>
                                    <tr>
                                        <td style={colStyleTitle}>CT比6</td>
                                    </tr>
                                </tbody>
                            </table>
                            <div style={{ position: 'absolute', top: '40%', left: '60%' }}>
                                <CircularProgress style={{ margin: 'auto' }} />
                            </div>
                        </div>
                    ) : (
                        <table className='polling' style={{ borderCollapse: 'collapse', width: '100%', margin: 'auto' }}>
                            <tbody>
                                <tr>
                                    <td style={colStyleTitle}>Io/Ior設定1</td>
                                    <td style={colStyle}>{settingInformation?.Io1}</td>
                                </tr>
                                <tr>
                                    <td style={colStyleTitle}>Io/Ior設定2</td>
                                    <td style={colStyle}>{settingInformation?.Io2}</td>
                                </tr>
                                <tr>
                                    <td style={colStyleTitle}>Io/Ior設定3</td>
                                    <td style={colStyle}>{settingInformation?.Io3}</td>
                                </tr>
                                <tr>
                                    <td style={colStyleTitle}>Io/Ior設定4</td>
                                    <td style={colStyle}>{settingInformation?.Io4}</td>
                                </tr>
                                <tr>
                                    <td style={colStyleTitle}>Io/Ior設定5</td>
                                    <td style={colStyle}>{settingInformation?.Io5}</td>
                                </tr>
                                <tr>
                                    <td style={colStyleTitle}>Io/Ior設定6</td>
                                    <td style={colStyle}>{settingInformation?.Io6}</td>
                                </tr>
                                <tr>
                                    <td style={colStyleTitle}>変圧器種類1</td>
                                    <td style={colStyle}>{settingInformation?.phase1}</td>
                                </tr>
                                <tr>
                                    <td style={colStyleTitle}>変圧器種類2</td>
                                    <td style={colStyle}>{settingInformation?.phase2}</td>
                                </tr>
                                <tr>
                                    <td style={colStyleTitle}>変圧器種類3</td>
                                    <td style={colStyle}>{settingInformation?.phase3}</td>
                                </tr>
                                <tr>
                                    <td style={colStyleTitle}>変圧器種類4</td>
                                    <td style={colStyle}>{settingInformation?.phase4}</td>
                                </tr>
                                <tr>
                                    <td style={colStyleTitle}>変圧器種類5</td>
                                    <td style={colStyle}>{settingInformation?.phase5}</td>
                                </tr>
                                <tr>
                                    <td style={colStyleTitle}>変圧器種類6</td>
                                    <td style={colStyle}>{settingInformation?.phase6}</td>
                                </tr>
                                <tr>
                                    <td style={colStyleTitle}>位相補正角設定1</td>
                                    <td style={colStyle}>{settingInformation?.angle1}</td>
                                </tr>
                                <tr>
                                    <td style={colStyleTitle}>位相補正角設定2</td>
                                    <td style={colStyle}>{settingInformation?.angle2}</td>
                                </tr>
                                <tr>
                                    <td style={colStyleTitle}>位相補正角設定3</td>
                                    <td style={colStyle}>{settingInformation?.angle3}</td>
                                </tr>
                                <tr>
                                    <td style={colStyleTitle}>位相補正角設定4</td>
                                    <td style={colStyle}>{settingInformation?.angle4}</td>
                                </tr>
                                <tr>
                                    <td style={colStyleTitle}>位相補正角設定5</td>
                                    <td style={colStyle}>{settingInformation?.angle5}</td>
                                </tr>
                                <tr>
                                    <td style={colStyleTitle}>位相補正角設定6</td>
                                    <td style={colStyle}>{settingInformation?.angle6}</td>
                                </tr>
                                <tr>
                                        <td style={colStyleTitle}>ZCT/Relay種類1</td>
                                        <td style={colStyle}>{settingInformation?.zct1}</td>
                                    </tr>
                                    <tr>
                                        <td style={colStyleTitle}>ZCT/Relay種類2</td>
                                        <td style={colStyle}>{settingInformation?.zct2}</td>
                                    </tr>
                                    <tr>
                                        <td style={colStyleTitle}>ZCT/Relay種類3</td>
                                        <td style={colStyle}>{settingInformation?.zct3}</td>
                                    </tr>
                                    <tr>
                                        <td style={colStyleTitle}>ZCT/Relay種類4</td>
                                        <td style={colStyle}>{settingInformation?.zct4}</td>
                                    </tr>
                                    <tr>
                                        <td style={colStyleTitle}>ZCT/Relay種類5</td>
                                        <td style={colStyle}>{settingInformation?.zct5}</td>
                                    </tr>
                                    <tr>
                                        <td style={colStyleTitle}>ZCT/Relay種類6</td>
                                        <td style={colStyle}>{settingInformation?.zct6}</td>
                                    </tr>
                                    <tr>
                                        <td style={colStyleTitle}>CT比1</td>
                                        <td style={colStyle}>{settingInformation?.ctratio1}</td>
                                    </tr>
                                    <tr>
                                        <td style={colStyleTitle}>CT比2</td>
                                        <td style={colStyle}>{settingInformation?.ctratio2}</td>
                                    </tr>
                                    <tr>
                                        <td style={colStyleTitle}>CT比3</td>
                                        <td style={colStyle}>{settingInformation?.ctratio3}</td>
                                    </tr>
                                    <tr>
                                        <td style={colStyleTitle}>CT比4</td>
                                        <td style={colStyle}>{settingInformation?.ctratio4}</td>
                                    </tr>
                                    <tr>
                                        <td style={colStyleTitle}>CT比5</td>
                                        <td style={colStyle}>{settingInformation?.ctratio5}</td>
                                    </tr>
                                    <tr>
                                        <td style={colStyleTitle}>CT比6</td>
                                        <td style={colStyle}>{settingInformation?.ctratio6}</td>
                                    </tr>
                            </tbody>
                        </table>
                    )}
                    <Typography display='flex' justifyContent='flex-end' padding='4px 4px 0 0'>最終取得日時：{settingInformation?.lastGetDatetime ?? '-'}</Typography>
                </CardContent>
            </Card >

            {
                openSelectDialog ? (
                    <SelectSettingInformationDialog_TJ360DeviceVerson
                        isOpen={true}
                        onOK={(data) => handleUpdateEquipmentOk(data)}
                        onCancel={handleUpdateEquipmentCancel}
                        data={editData}
                        dialogTitle={updateDialogTitle}
                    />
                ) : (
                    <div />
                )
            }
            <FetchHelper fetchId={fetchId + deviceNo} onComplete={(success, data, error) => success ? handleRefreshSuccess(data) : handleError(success, data, error)} />
            <FetchHelper fetchId="UPDATE_SETTING_INFORMATION" method="POST" onComplete={(success, data, error) => success ? handleUpdateSuccess(success, data, error) : handleUpdateError(success, data, error)} />
        </>
    );
};
const mapStateToProps = (state: ApplicationState) => ({
    fetchState: selectors.getFetchState(
        state,
        fetchId
    ) as FetchState,
});
const mapDispatchToProps = {
    onUpdate: (code: string, mainid: string, data: any) => actionCreators.fetch("UPDATE_SETTING_INFORMATION", `/polling-nrf/set?code=${code}`, 'POST', data, false, true),
    onRefresh: (params: any, fetchId: string) => actionCreators.fetch(fetchId, `/polling-nrf/get`, "GET", params),
    onError: (success: boolean, data: any, error: any) =>
        actionCreators.showMessage({
            type: "error",
            title: `Io/Ior設定情報取得`,
            body: "Io/Ior設定情報取得できませんでした。",
        }),
    onUpdateSuccess: () =>
        actionCreators.showMessage({
            type: "info",
            title: `Io/Ior設定情報変更`,
            body: "Io/Ior設定情報を変更しました。",
        }),
    onUpdateError: (success: boolean, data: any, error: any) =>
        actionCreators.showMessage({
            type: "error",
            title: `Io/Ior設定情報変更`,
            body: "Io/Ior設定情報を変更できませんでした。",
        }),
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(SettingInformation_TJ360VersionDevice);

